/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
export const AB_ITEM_SEPARATOR = Symbol("AbItemSeparator");
export let AbItemSeparator;
(function (_AbItemSeparator) {
  const isSeparator = _AbItemSeparator.isSeparator = v => {
    return v === AB_ITEM_SEPARATOR;
  };
  const isNotSeparator = _AbItemSeparator.isNotSeparator = v => {
    return v !== AB_ITEM_SEPARATOR;
  };
  const deduplicateSeparators = _AbItemSeparator.deduplicateSeparators = items => {
    const filteredItems = items.filter((item, index) => {
      // First filter removes dupes
      if (item !== AB_ITEM_SEPARATOR) return true;
      return !(index > 0 && items[index - 1] === AB_ITEM_SEPARATOR);
    });
    if (filteredItems[0] === AB_ITEM_SEPARATOR) filteredItems.splice(0, 1);
    if (filteredItems[filteredItems.length - 1] === AB_ITEM_SEPARATOR) filteredItems.splice(filteredItems.length - 1, 1);
    return filteredItems;
  };
})(AbItemSeparator || (AbItemSeparator = {}));
//# sourceMappingURL=AbItemSeparator.js.map
